import spacetime from 'spacetime';

import { tzMoscow } from 'CorePackage/MainModule/constants/timeZone';

import { ICreatePlanForm } from '../components/CreatePlanModal';

const CURR_DATE = spacetime.now(tzMoscow);
const CURR_YEAR = new Date().getFullYear();
const PLAN_YEAR = CURR_DATE.isAfter(spacetime(`November 3 ${CURR_YEAR}`, tzMoscow)) ? CURR_YEAR + 2 : CURR_YEAR + 1;

export const initialCreatePlanForm: ICreatePlanForm = {
  startDate: `${PLAN_YEAR}-01-01`,
  endDate: `${PLAN_YEAR}-12-31`,
};
